module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.svg?07c3c549e00186f1c17541f3f7ecfb76";